/**
 * Naming convention for the GIS layer id used in the Esri map.mapInstance.map.layers.items array.
 * @param gisService - A GIS service object from the giServices redux state.
 * @returns String
 */
export const getGISLayerID = gisService =>
  gisService
    ? `gis-service${
        gisService?.service_type > -1 ? `-${gisService.service_type}` : ''
      }${gisService?.id > -1 ? `-${gisService.id}` : ''}`
    : '';
